import * as React from "react";
import { UitkText } from "uitk-react-text";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { LocalizedComponentProps, useLocalization } from "@shared-ui/localization-context";
import { withLocalization, LocalizedComponentClass } from "bernie-l10n";
import {
  Action,
  FlexTrackingInfo,
  sendImmediateClickstreamTrackEvent,
} from "components/utility/analytics/FlexAnalyticsUtils";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";

export interface RateCalendarFooterProps extends LocalizedComponentProps {
  displayPositive: boolean;
  displayNegative: boolean;
}

const LocalizedRateCalendarFooter = (props: RateCalendarFooterProps) => {
  const { formatText } = useLocalization();
  const track = useClickTracker();
  const { displayPositive, displayNegative } = props;

  const legendHigherPrices = formatText("wizard.ratecalendar.footer.legend.negative");
  const legendLowerPrices = formatText("wizard.ratecalendar.footer.legend.positive");

  if (displayPositive || displayNegative) {
    React.useEffect(() => {
      const flexTracking: FlexTrackingInfo = {
        moduleName: "PriceGuidance",
        rfrr: "DatePickerOpened",
        action: Action.IMPRESSION,
      };
      sendImmediateClickstreamTrackEvent(flexTracking, track);
    });
  }

  return (
    <UitkLayoutFlex>
      {displayNegative && (
        <>
          <UitkLayoutFlexItem key={`legend-icon-1`}>
            <UitkSpacing className={`rate-calendar-footer negative`}>
              <UitkIcon name={"arrow_drop_down"} size={UitkIconSize.MEDIUM} />
            </UitkSpacing>
          </UitkLayoutFlexItem>
          <UitkLayoutFlexItem key={`legend-label-1`}>
            <UitkSpacing padding={{ blockstart: "one", inlinestart: "one", inlineend: "three" }}>
              <UitkText weight={"bold"}>{legendLowerPrices}</UitkText>
            </UitkSpacing>
          </UitkLayoutFlexItem>
        </>
      )}
      {displayPositive && (
        <>
          <UitkLayoutFlexItem key={`legend-icon-2`}>
            <UitkSpacing className={`rate-calendar-footer positive`}>
              <UitkIcon name={"arrow_drop_up"} size={UitkIconSize.MEDIUM} />
            </UitkSpacing>
          </UitkLayoutFlexItem>
          <UitkLayoutFlexItem key={`legend-label-2`}>
            <UitkSpacing padding={{ blockstart: "one", inlinestart: "one", inlineend: "three" }}>
              <UitkText weight={"bold"}>{legendHigherPrices}</UitkText>
            </UitkSpacing>
          </UitkLayoutFlexItem>
        </>
      )}
    </UitkLayoutFlex>
  );
};

export const RateCalendarFooter: LocalizedComponentClass<RateCalendarFooterProps> = withLocalization(
  LocalizedRateCalendarFooter
);
